import * as React from 'react';
import { FieldProps, getIn } from 'formik';
import TextField from 'material-ui/TextField';

export const FormikMaterialTextField = ({
  field: { onChange, onBlur, ...field },
  form: { touched, errors },
  ...props
}: FieldProps<any>) => (
  <TextField
    errorText={getIn(touched, field.name) && getIn(errors, field.name)}
    {...field}
    {...props}
    onChange={(event) => onChange(event)}
    onBlur={onBlur}
  />
);
